module.exports = __webpack_public_path__ + "static/85-1-acd41d23665e511bb8920167438a7ab5.jpg";